import { envTypeGet } from "./common";

export const staticContentPath = (...args: string[]): string => {
  const envType = envTypeGet();
  let url: string = "";
  let urlBase = "http://localhost:3011/static-content";
  if (envType === "production") {
    urlBase = "https://unos-rad.emlearn.info/static-content";
  }
  url = urlBase;
  if (args.length > 0) {
    url += "/" + args.join("/");
  }

  return url;
};
